import React, { useCallback, useEffect, useState } from 'react'
import { Dialog, Transition } from "@headlessui/react";
import SecondaryButton from "components/SecondaryButton";
import { getProfile } from 'services/apiRoutes';
import ReactPlayer from 'react-player';
import { useParams } from 'react-router-dom';



export default function ModalVidio() {
  const {slug} =useParams()
  const [profile,setProfile]=useState();
  
   const profileAPI = useCallback(async () => {
     const res = await getProfile(slug);
     if (res.error) {
       return res.message;
     } else {
       const { data } = res.data;
       setProfile(data);
     }
   }, [slug]);

   useEffect(() => {
     profileAPI();
   }, [profileAPI, profile]);

    let [isOpen, setIsOpen] = useState(false);

    function closeModal() {
      setIsOpen(false);
    }

    function openModal() {
      setIsOpen(!isOpen);
    }

   return (
     <>
       <SecondaryButton
         label="Video Profil Gampong"
         secondType
         onClick={openModal}
       />
       <Transition appear show={isOpen} as="div">
         <Dialog as="div" className="relative z-10" onClose={closeModal}>
           <Transition.Child
             as="div"
             enter="ease-out duration-300"
             enterFrom="opacity-0"
             enterTo="opacity-100"
             leave="ease-in duration-200"
             leaveFrom="opacity-100"
             leaveTo="opacity-0"
           >
             <div className="fixed inset-0 bg-black bg-opacity-30" />
           </Transition.Child>

           <div className="fixed inset-0 overflow-y-auto">
             <div className="flex items-center justify-center min-h-full p-4 text-center">
               <Transition.Child
                 as="div"
                 enter="ease-out duration-300"
                 enterFrom="opacity-0 scale-95"
                 enterTo="opacity-100 scale-100"
                 leave="ease-in duration-200"
                 leaveFrom="opacity-100 scale-100"
                 leaveTo="opacity-0 scale-95"
               >
                 <Dialog.Panel className="p-3 overflow-hidden text-left align-middle transition-all transform bg-white border shadow-xl lg:w-full rounded-2xl border-secondary">
                   <div className="mt-2">
                     <ReactPlayer
                       url={
                         profile?.ProfilDesa
                           ? profile?.ProfilDesa?.url_video
                           : null
                       }
                     />
                   </div>
                 </Dialog.Panel>
               </Transition.Child>
             </div>
           </div>
         </Dialog>
       </Transition>
     </>
   );
}
